import * as React from 'react';
import { CoreProps } from '../types';
import { Font } from 'src/design-system/text/font';
import styles from './input.module.scss';

interface InputProps {
    id: string;
    type: string;
    name: string;
    placeholder?: string;
    value: string;
    onchange?: any;
    onblur?: any;
    label?: string;
    autoComplete?: boolean;
    require?: boolean;
    readOnly?: boolean;
}

export const Input = (props: InputProps & CoreProps) => {
    const {
        id,
        type,
        name,
        placeholder,
        value,
        onchange,
        onblur,
        label,
        autoComplete,
        require,
        className = undefined,
        composeClassName = undefined,
        readOnly,
    } = props;
    const clss = [composeClassName, className].filter(Boolean).join(' ');

    return (
        <div className={styles.input}>
            {label && (
                <Font.OxaniumRegular as="span" mobile="12" desktop="12" className={styles.label}>
                    <label htmlFor={id}>
                        {label}
                        {require ? ' *' : ''}
                    </label>
                </Font.OxaniumRegular>
            )}
            <input
                id={id}
                type={type}
                name={name}
                placeholder={placeholder ? placeholder : ''}
                value={value}
                className={clss}
                onChange={onchange}
                onBlur={onblur}
                autoComplete={!autoComplete ? 'off' : 'on'}
                readOnly={readOnly}
            />
        </div>
    );
};
